var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _c(
      "div",
      { staticStyle: { width: "80%", "margin-left": "12%" } },
      [
        _c("h1", [_vm._v(_vm._s(_vm.$t("Insurance.FreightInsurance")))]),
        _c("hr", { staticStyle: { border: "1px solid black" } }),
        _c(
          "el-row",
          { attrs: { gutter: 22 } },
          [
            _c(
              "el-col",
              { staticStyle: { "margin-left": "20px" }, attrs: { span: 2 } },
              [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("SystemMaintenance.ServiceProviders")))
                ])
              ]
            ),
            _vm._l(_vm.serviceProviders, function(item, index) {
              return _c(
                "div",
                { key: index, staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-col",
                    { staticClass: "title-col", attrs: { span: 5 } },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm.imgAgentIcon(item),
                          width: "90%",
                          height: "8%"
                        }
                      })
                    ]
                  )
                ],
                1
              )
            })
          ],
          2
        ),
        _c(
          "el-row",
          { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
          [
            _c("el-col", { staticClass: "left-20-top-8", attrs: { span: 2 } }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("Insurance.Rate")))])
            ]),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [
                _vm._v(" 进/出口货运险：集装箱普货0.02%起"),
                _c("br"),
                _vm._v(" 国内货运险：普货综合险0.02%起"),
                _c("br"),
                _vm._v(" （FMC、上架险、邮包险、信用险单独询价） ")
              ]
            ),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [
                _vm._v(" 国内货物运输保险：0.006%起；"),
                _c("br"),
                _vm._v(" 出口运输货物保险：0.02%起；"),
                _c("br"),
                _vm._v(" 可根据客户情况开发产品和厘定费率 ")
              ]
            ),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [_vm._v(" 普货0.02% ")]
            ),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [
                _vm._v(" 进/出口货物：0.02%；"),
                _c("br"),
                _vm._v(" 国内货物：0.02%；"),
                _c("br"),
                _vm._v(" 海陆空及联运费率相同；"),
                _c("br"),
                _vm._v(" 普货0免赔、免对货代追偿 ")
              ]
            )
          ],
          1
        ),
        _c(
          "el-row",
          { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
          [
            _c("el-col", { staticClass: "left-20-top-8", attrs: { span: 2 } }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))])
            ]),
            _c(
              "el-col",
              { staticClass: "page-col", attrs: { span: 5 } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "medium" },
                    on: {
                      click: function($event) {
                        return _vm.oepnInsureDialog("xnhb")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                ),
                _c("br"),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-top": "8px" },
                    on: {
                      change: function(val) {
                        return _vm.changeRememberAgent(val, "xnhb")
                      }
                    },
                    model: {
                      value: _vm.rememberXnhb,
                      callback: function($$v) {
                        _vm.rememberXnhb = $$v
                      },
                      expression: "rememberXnhb"
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Insurance.RememberOperationDirectly")) +
                        " "
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { staticClass: "page-col", attrs: { span: 5 } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "medium" },
                    on: {
                      click: function($event) {
                        return _vm.oepnInsureDialog("kebao")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                ),
                _c("br"),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-top": "8px" },
                    on: {
                      change: function(val) {
                        return _vm.changeRememberAgent(val, "kebao")
                      }
                    },
                    model: {
                      value: _vm.rememberKebao,
                      callback: function($$v) {
                        _vm.rememberKebao = $$v
                      },
                      expression: "rememberKebao"
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Insurance.RememberOperationDirectly")) +
                        " "
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { staticClass: "page-col", attrs: { span: 5 } },
              [
                _vm.sourceFrom === "job"
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "medium" },
                        on: {
                          click: function($event) {
                            return _vm.toInsure("htjj")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                    )
                  : _vm._e(),
                _c("br"),
                _vm.sourceFrom === "job"
                  ? _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-top": "8px" },
                        on: {
                          change: function(val) {
                            return _vm.changeRememberAgent(val, "htjj")
                          }
                        },
                        model: {
                          value: _vm.rememberHtjj,
                          callback: function($$v) {
                            _vm.rememberHtjj = $$v
                          },
                          expression: "rememberHtjj"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("Insurance.RememberOperationDirectly")
                            ) +
                            " "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "el-col",
              { staticClass: "page-col", attrs: { span: 5 } },
              [
                _vm.sourceFrom === "job"
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "medium" },
                        on: {
                          click: function($event) {
                            return _vm.toInsure("lhb")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                    )
                  : _vm._e(),
                _c("br"),
                _vm.sourceFrom === "job"
                  ? _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-top": "8px" },
                        on: {
                          change: function(val) {
                            return _vm.changeRememberAgent(val, "lhb")
                          }
                        },
                        model: {
                          value: _vm.rememberLhb,
                          callback: function($$v) {
                            _vm.rememberLhb = $$v
                          },
                          expression: "rememberLhb"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("Insurance.RememberOperationDirectly")
                            ) +
                            " "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "el-row",
          { staticStyle: { "margin-top": "50px" }, attrs: { gutter: 22 } },
          [
            _c("el-col", { staticClass: "left-20-top-8", attrs: { span: 2 } }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("Insurance.ServiceAdvantages")))])
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(
                " 1.优惠政策：首月投保客户当月保费500元以上，可享受赠送RMB150.0000保额的福利；"
              ),
              _c("br"),
              _vm._v(" 2、特殊承保国家："),
              _c("br"),
              _vm._v("境外-境外、伊朗、伊拉克、俄罗斯均可承保"),
              _c("br"),
              _vm._v(" 3、特殊承保货物："),
              _c("br"),
              _vm._v(
                "危险品2.3.4.5.6.8类、烟花爆竹、精密仪器、商品车、船舶游艇、散装货、粮食货等均可承保；"
              ),
              _c("br"),
              _vm._v(
                " 4、跨境物流服务：可保九大海外仓上架:FBA+沃尔玛+谷仓+万邑通+4PX+菜鸟仓+Cdiscount+京东仓+易达仓"
              ),
              _c("br"),
              _vm._v(" 5、解决以下问题："),
              _c("br"),
              _vm._v(
                " a、经营问题：应收账款、错发错运、关税、罚款、堆存费、运输协议审核、箱体损坏"
              ),
              _c("br"),
              _vm._v(
                " b、资质问题：FMC资质认证、 产品上架、进出口产品责任、供应商审核"
              ),
              _c("br"),
              _vm._v(
                " 6、增值服务：法律咨询、协助残值处理、海关数据查询、境外企查查、专业培训（线上\\线下均可预约）、风险播报(真实案例分享，投保注意事项) "
              )
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(" 1.低价格，高保障"),
              _c("br"),
              _vm._v(" 2.产品丰富，特别是场景碎片化保险产品"),
              _c("br"),
              _vm._v(" 3.出险后全程协助索赔跟踪服务，线上化操作"),
              _c("br"),
              _vm._v(" 4.AI风险体检，让客户做好风险防范，买到最该买的保险"),
              _c("br"),
              _vm._v(" 5.AI指导运输货物风险评估，早知风险"),
              _c("br"),
              _vm._v(" 6.货物实时跟踪，实时查询风险状态"),
              _c("br"),
              _vm._v(
                " 7.传统保险产品丰富：FMC、FSL、箱体险、邮包险、信用险、上架险、供应商审核、法务产品、物流责任险，雇主险、团体意 外险、仓储险、产品责任险 "
              )
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(" 1、保险产品：提供行业内量身定制适用于企业的保险方案。"),
              _c("br"),
              _vm._v(
                " 2、理赔服务：自有全资保险公估子公司协助客户进行保险索赔、残值处理等全方位服务；英国劳合社在中国大陆指定的独家代理人。"
              ),
              _c("br"),
              _vm._v(
                " 3、费率浮动机制：为每一个客户提供费率浮动机制“降本增效”。"
              ),
              _c("br"),
              _vm._v(" 4、培训服务：不定期组织线上事故预防服务培训。"),
              _c("br"),
              _vm._v(" 5、风险提示：实时推送政策信息、风险预警信息。"),
              _c("br"),
              _vm._v(
                " 6、全产品条线服务：监装监卸、风险评估服务，邮包险、仓储类险种、雇主责任、团体意外险、财产险、产品责任险等全险种服务。 "
              )
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(" 1、可开通月结保费服务；"),
              _c("br"),
              _vm._v(" 2、保仓到仓，免对货代追偿；"),
              _c("br"),
              _vm._v(" 3、普货0免赔；"),
              _c("br"),
              _vm._v(
                " 4、全球进出口海陆空运及联运均可保，非洲、俄罗斯等特殊地区国家也可保，详情见保障服务；"
              ),
              _c("br"),
              _vm._v(" 5、投保、理赔、批改全程一对一专人在线服务；"),
              _c("br"),
              _vm._v(
                " 6、跨境电商物流保险服务：12大海外仓（亚马逊仓、菜鸟仓、京东仓、沃尔玛、易达仓、万邑通、速卖通、橙联、谷仓、4PX、Cdiscount仓、eBay）可保到仓、上架，私人地址可保到仓；"
              ),
              _c("br"),
              _vm._v(
                " 7、18年专注物流行业，全链路专属定制保险产品：跨境电商物流保险、货代责任险、集装箱险、仓储险、运费险、物流责任险、员工保险等，全面覆盖物流企业保险需求。"
              ),
              _c("br"),
              _vm._v(
                " 8、携手骏日提供：FMC/NVOCC资质备案、AMS代发40元/票、ISF/ACI/EMF/AFR等舱单代发；"
              ),
              _c("br"),
              _vm._v(
                " 9、数字化风控体系赋能物流企业：定期协助企业筛查经营及货运风险，专业人士限时免费提供全面风控解决方案；"
              ),
              _c("br")
            ])
          ],
          1
        ),
        _c("h1", [_vm._v(_vm._s(_vm.$t("Insurance.Scanning")))]),
        _c("hr", { staticStyle: { border: "1px solid black" } }),
        _c(
          "el-row",
          { attrs: { gutter: 22 } },
          [
            _c(
              "el-col",
              { staticStyle: { "margin-left": "20px" }, attrs: { span: 2 } },
              [_c("h3", [_vm._v(_vm._s(_vm.$t("Insurance.InsuranceCompany")))])]
            ),
            _vm._l(_vm.serviceProviders, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "margin-top-8",
                  staticStyle: { "text-align": "center" }
                },
                [
                  _c(
                    "el-col",
                    { staticClass: "title-col", attrs: { span: 5 } },
                    [
                      _c("div", { staticStyle: { width: "100%" } }, [
                        _c("img", {
                          staticStyle: { "margin-right": "5px" },
                          attrs: {
                            src: _vm.imgIcon("tpybx"),
                            width: "40%",
                            height: "3%"
                          }
                        }),
                        _c("img", {
                          attrs: {
                            src: _vm.imgIcon("zgpa"),
                            width: "40%",
                            height: "3%"
                          }
                        }),
                        _c("br"),
                        _c("img", {
                          staticStyle: { "margin-right": "5px" },
                          attrs: {
                            src: _vm.imgIcon("zgrb"),
                            width: "40%",
                            height: "3%"
                          }
                        }),
                        item !== "lhb"
                          ? _c("img", {
                              attrs: {
                                src: _vm.imgCompanyIcon(item),
                                width: "40%",
                                height: "3%"
                              }
                            })
                          : _vm._e()
                      ])
                    ]
                  )
                ],
                1
              )
            })
          ],
          2
        ),
        _c(
          "el-row",
          { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
          [
            _c("el-col", { staticClass: "left-20-top-8", attrs: { span: 2 } }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("Insurance.Deductible")))])
            ]),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [_vm._v(" 集装箱普货无免赔（其他免赔按约定）"), _c("br")]
            ),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [_vm._v(" 集装箱普货无免赔（其他免赔按约定）"), _c("br")]
            ),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [
                _vm._v(" 普通货物无免赔（其他免赔按约定）"),
                _c("br"),
                _vm._v(" 特殊货物每次事故绝对免赔额不低于保额的2.5% ")
              ]
            ),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [_vm._v(" 普货0免赔（其它免赔按约定） "), _c("br")]
            )
          ],
          1
        ),
        _c(
          "el-row",
          { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
          [
            _c("el-col", { staticClass: "left-20-top-8", attrs: { span: 2 } }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("Insurance.InsuranceCoverage")))])
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(" 《海洋运输货物保险条款》"),
              _c("br"),
              _vm._v(" 《航空运输货物保险条款》"),
              _c("br"),
              _vm._v(" 《陆上运输货物保险条款（火车、汽车）》"),
              _c("br"),
              _vm._v(" 《海洋运输冷藏货物保险条款》"),
              _c("br"),
              _vm._v(" 《国内水路、陆路货物运输保险条款》"),
              _c("br"),
              _vm._v(
                " (国际一切险、平安险、水渍险范围，国内综合险、基本险范围)"
              ),
              _c("br")
            ]),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [_vm._v(" 海运、陆运、空运一切险 "), _c("br")]
            ),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(" 中国往返世界各地，"),
              _c("br"),
              _vm._v(" 但运自或运往下列国家或地区的任何货物另议："),
              _c("br"),
              _vm._v(" 非洲、朝鲜、古巴、俄罗斯、乌克兰等"),
              _c("br")
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(
                " 1、海运、陆运、空运一切险，磕碰、丢失、火灾、浸湿等可保；"
              ),
              _c("br"),
              _vm._v(" 2、可附加战争、罢工、盗抢险，可满足信用证要求；"),
              _c("br"),
              _vm._v(
                " 3、特殊可保国家：非洲地区、拉美地区、墨西哥、巴尔干地区、波黑、白俄罗斯、缅甸、科特迪瓦、民主刚果共和国、象牙海岸、中非共和国、埃及、厄立特里亚、利比里亚、苏丹、南苏丹、突尼斯、乌克兰、摩尔多瓦、黎巴嫩、几内亚比绍共和国、卢旺达、塞拉利昂、海地、也门； "
              )
            ])
          ],
          1
        ),
        _c(
          "el-row",
          { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
          [
            _c("el-col", { staticClass: "left-20-top-8", attrs: { span: 2 } }, [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("Insurance.SpecialInstructions")))
              ])
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(
                " 特殊商品（精密仪器、鲜活动植物、果蔬、禽鱼类、大宗散货、谷物粮食、危险品、大件货物、车辆、甲板货及舱面货、21-28年船龄集装箱船、滚装船运输）可以单独报价 "
              )
            ]),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [_vm._v(" 全部承保 ")]
            ),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [_vm._v(" 特殊商品（如精密设备等）可以单独报价"), _c("br")]
            ),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(
                " 1、特殊货物（精密仪器、鲜活动植物、果蔬、禽鱼类、大宗散货、谷物粮食、危险品、大件货物、车辆、甲板货及舱面货、21-28年船龄集装箱船、滚装船运输）可单独询价；"
              ),
              _c("br"),
              _vm._v(" 2、货量可单独定制方案；"),
              _c("br"),
              _vm._v(" 3、费率可根据特殊情况调整； ")
            ])
          ],
          1
        ),
        _c(
          "el-row",
          { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
          [
            _c("el-col", { staticClass: "left-20-top-8", attrs: { span: 2 } }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("Insurance.ClaimsService")))])
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(
                " 24小时线上报案、可自主查询索赔进度， 专业的案件管理人全程协助理赔， 每2周有案例分享和风险播报； "
              )
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(" 专人负责理赔服务，与各保司都有良好合作历史 "),
              _c("br")
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(" 可以在全球进行理赔服务，快速响应残值处理。 ")
            ]),
            _c(
              "el-col",
              {
                staticClass: "col-style",
                staticStyle: { "text-align": "center" },
                attrs: { span: 5 }
              },
              [_vm._v(" 由领航保的理赔人员和保险公司对接 ")]
            )
          ],
          1
        ),
        _c(
          "el-row",
          { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
          [
            _c("el-col", { staticClass: "left-20-top-8", attrs: { span: 2 } }, [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("Insurance.ServiceProviderIntroduction")))
              ])
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(
                " “小牛货保”的平台宗旨是打造一个“投的放心，买的舒心，赔的省心”的一体化综合风控平台。"
              ),
              _c("br"),
              _vm._v(
                " 小牛货保坚持用精益求精的企业精神在保险产品、售后理赔、增值服务上不断创新，小牛货保希望 能够给用户带来一种全新的投保体验，欢迎大家来单咨询，争做“小牛人”。 "
              )
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(
                " 恪保科技（前身华一保险经纪）是一家航运物流数据与保险数据连接的SAAS平台公司， 拥有独立网上投保系统并为自营用户、SAAS平台货代用户、 保险经代公司、保险公司、再保险公司提供投保、 产品部署、智能风险识别、风险预警、场景保险服务、智能理赔等服务。 "
              )
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(
                " 北京华泰保险公估有限公司是华泰经纪的全资子公司，简称“华泰公估”。"
              ),
              _c("br"),
              _vm._v(
                " 华泰公估是英国劳合社(Lloyd's)在中国大陆指定的独家代理人( Lloyd's Agency ),从1993年起即为全球一百多家保险公司提供保单项下船舶、货物、工程、财产等的检验、理赔服务以及风险管理咨询。全球劳合社网络都可借用，可以在全球进行理赔服务，快速响应残值处理。"
              ),
              _c("br"),
              _vm._v(
                " 华泰保险经纪有限公司成立于1993年，是经中国人民银行批准的国内第一家全国性保险中介服务企业。"
              ),
              _c("br"),
              _vm._v(
                " 公司具有强大的股东背景，三大股东分别为中国再保险（集团）有限公司、中国太平保险控股有限公司和中国能源建设集团有限公司；其中，控股股东——中国再保险（集团）有限公司是中国唯一一家本土再保险集团。"
              ),
              _c("br"),
              _vm._v(
                " 公司定位于“系统资源整合商、专业服务集成商”，具有风险管理、保险方案设计和采购安排、保险理赔等全流程、全险种中介服务能力，发展成为集经纪、公估、海事、海旅、人身险和再保险经纪为一体的多元化、专业化、国际化的综合性保险中介企业。"
              ),
              _c("br"),
              _vm._v(
                " 公司拥有24家省级分公司和1家子公司（北京华泰保险公估有限公司），形成了一张立足中心城市、辐射全国的服务网络，服务触角随着“一带一路”战略发展逐步向全球延伸。 "
              )
            ]),
            _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
              _vm._v(
                " 领航国际保险经纪有限公司成立于2005年，隶属于华商纵横集团，是经国家金融监督管理总局批准的全国性的、拥有互联网资质的保险经纪公司，注册资金5000万元；"
              ),
              _c("br"),
              _vm._v(
                " 领航总部位于北京，在天津、青岛、上海、厦门、广州、深圳等城市设有分公司，拥有完整的全球服务网络；"
              ),
              _c("br"),
              _vm._v(
                " 领航通过整合国内外保险优势资源，专注于航运和消费金融，以保险产品和模式创新，为物流和消费行业提供数字化的风险管理方案，致力成为行业领先企业；"
              ),
              _c("br"),
              _vm._v(
                " 领航货运险，跨境电商保险、货代责任险，美国FMC资质办理及AMS舱单服务（携手骏日），已为1.3万家物流企业提供行业保险解决方案，依托强大的国际网络能够为“一带一路和引进来、走出去”提供优质的企业服务。"
              ),
              _c("br"),
              _vm._v(" 追求：做航运物流及消费金融领域保险的领航者；"),
              _c("br"),
              _vm._v(
                " 使命：创新产品和模式，成为行业的风险管控专家，提供保险和服务的数字化服务；"
              ),
              _c("br"),
              _vm._v(
                " 定位：聚焦航运物流及消费金融领域的风险需求，创新保险解决方案，满足客户个性化保险需求。 "
              ),
              _c("br")
            ])
          ],
          1
        ),
        _c("h1", [
          _vm._v(" " + _vm._s(_vm.$t("Insurance.Specification")) + " "),
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showExpand,
                expression: "!showExpand"
              }
            ],
            staticClass: "el-icon-arrow-right",
            staticStyle: {
              float: "right",
              "font-size": "45px",
              border: "5px",
              "margin-top": "-10px"
            },
            on: { click: _vm.changeShowExpand }
          }),
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showExpand,
                expression: "showExpand"
              }
            ],
            staticClass: "el-icon-arrow-down",
            staticStyle: {
              float: "right",
              "font-size": "45px",
              border: "5px",
              "margin-top": "-10px"
            },
            on: { click: _vm.changeShowExpand }
          })
        ]),
        _c("hr", { staticStyle: { border: "1px solid black" } }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showExpand,
                expression: "showExpand"
              }
            ]
          },
          [
            _c("p", { staticStyle: { color: "red" } }, [
              _vm._v(
                "承保政策实时随保司政策变化，如有变化服务商将通知、公示；政策条款以服务商官网最新说明为准，本页面仅供参考，更多供应商陆续上新中"
              )
            ]),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [_c("h3", [_vm._v(_vm._s(_vm.$t("Insurance.SpecialCargo")))])]
                ),
                _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
                  _vm._v(
                    " 线上客服一对一实时动态报价，沃行客户可享受最优费率，首月新客投保立减，欢迎体验。 "
                  )
                ]),
                _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
                  _vm._v(" 1.冷藏品：万3起，免赔为保额的2%；"),
                  _c("br"),
                  _vm._v(" 2.危险品（1、7类除外）：万4起，免赔为保额的0.5% ；"),
                  _c("br"),
                  _vm._v(
                    " 3.太阳能电池板/光伏：万4起，免赔为保额的3%或损失金额的10%，取高 ；"
                  ),
                  _c("br"),
                  _vm._v(
                    " 4.白酒：万3起，免赔额为保额的3%或损失金额的10%二者取高"
                  ),
                  _c("br"),
                  _vm._v(
                    " 5.精密仪器：万5起，免赔保额的0.5%或损失金额的10%取高，国内运输，万4，免赔10000RMB或损失金额的10%取高；"
                  ),
                  _c("br"),
                  _vm._v(" 6.滚装货物：万5起，免赔保额的1%或损失金额的10%"),
                  _c("br"),
                  _vm._v(" 单独询价货物（需询价后承保）："),
                  _c("br"),
                  _vm._v(" 1.精密仪器"),
                  _c("br"),
                  _vm._v(" 2.（各保司定义精密仪器略有差异）；"),
                  _c("br"),
                  _vm._v(" 3.鲜活动植物"),
                  _c("br"),
                  _vm._v(
                    " 4.（各类活体的动物，各种植物，如鲜花、巴西木苗、花籽球等，这一条主要是针对活体动物）"
                  ),
                  _c("br"),
                  _vm._v(
                    " 5.贵重金属、有价证券、乐器、家具、工艺品等具有收藏价值物品"
                  ),
                  _c("br"),
                  _vm._v(
                    " 6.（包括各类雕刻、编织、艺术品、刺绣、古董、字画、瓷器、玉雕及其他玉石制品等、现金、有价证券、金银、金银制品、纪念币、珠宝、钻石、首饰、玉器、贵重金属、首饰、古币、 古玩、古书、古画、邮票、艺术品、稀有金属、文物、古董、票据、文件、档案、账册、图纸、技术资料、名画、古代化石、家私、乐器等、珠宝、私人物品、具有收藏价值的货物，红木家具、进口家具、钢琴、乐"
                  ),
                  _c("br"),
                  _vm._v(" 7.武器、弹药及其零配件"),
                  _c("br"),
                  _vm._v(" 8.（各类军用装备、武装直升机、导弹发射架等等"),
                  _c("br"),
                  _vm._v(" 9.风力发电相关主机、叶片"),
                  _c("br"),
                  _vm._v(" 10.拖航运输货物、半潜船运输货物"),
                  _c("br"),
                  _vm._v(" 11.国家法律、法规禁止邮寄或运输的物品；"),
                  _c("br")
                ]),
                _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
                  _vm._v(" 1.冷藏品: 万4起"),
                  _c("br"),
                  _vm._v(" 2.易碎品: 万4起"),
                  _c("br"),
                  _vm._v(" 3.危险品:万4.5起"),
                  _c("br"),
                  _vm._v(" 4.太阳能电池板/光伏:万4.5起"),
                  _c("br"),
                  _vm._v(" 5.精密设备:万5起"),
                  _c("br"),
                  _vm._v(" 6.电池: 万3.5起"),
                  _c("br"),
                  _vm._v(" 7.商品车: 万5起"),
                  _c("br"),
                  _vm._v(" 8.红酒、白酒:万4起"),
                  _c("br"),
                  _vm._v(" 单独询价货物（需询价后承保）："),
                  _c("br"),
                  _vm._v(" 1、工艺品、武器、弹药及其零配件。"),
                  _c("br"),
                  _vm._v(
                    " 2、鲜活动植物、瓜果蔬菜、蛋类、各类农作物及粮食类货物；"
                  ),
                  _c("br"),
                  _vm._v(
                    " 3、工艺品（包括但不限于各类雕刻、编织、艺术品、、刺绣、古董、字画、瓷器、玉雕及其他玉石制品等）、现金、有价证券、珠宝、具有收藏价值的货物（包括但不限于红木家具、进口家具、钢琴、乐器等）以及计算机软件等难以客观确定保险价值的货物；"
                  ),
                  _c("br"),
                  _vm._v(
                    " 4、手机、电脑、液晶电视、液晶显示器、平板电脑、数码相机以及其他电子3C产品。"
                  ),
                  _c("br"),
                  _vm._v(" 5、疫苗、针剂、液体药品、试剂、血液制品；"),
                  _c("br")
                ]),
                _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
                  _vm._v(" 1.精密仪器（精密仪器的判断条件是:"),
                  _c("br"),
                  _vm._v(" A.对运输有特别的防震动、防倾斜、防尘等特殊要求。"),
                  _c("br"),
                  _vm._v(" B.受国内维修能力所限，设备受损后无法在国内修复。"),
                  _c("br"),
                  _vm._v(" C.单件货物保额超过 RMB500 万元。满足上述"),
                  _c("br"),
                  _vm._v(" 条件之一的即为精密设备或仪器）；"),
                  _c("br"),
                  _vm._v(
                    " 2.大宗散货（包括散装的农产品、化工产品、煤、油品）；"
                  ),
                  _c("br"),
                  _vm._v(" 3.锂电池"),
                  _c("br")
                ])
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("Insurance.CargoExclusion")))
                    ])
                  ]
                ),
                _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
                  _vm._v(" 1.28年以上船龄集装箱船、滚装船运输；"),
                  _c("br"),
                  _vm._v(" 2.枪支弹药、爆炸品、放射性同位素、军用武器或装备；"),
                  _c("br"),
                  _vm._v(
                    " 3.拖驳运输的货物，以及通过非正常贸易方式买卖的货物；"
                  ),
                  _c("br"),
                  _vm._v(
                    " 4.工艺品（包括各类雕刻、编制品、刺绣、瓷器、玉器等）、现金、有价证券、计算机软件、金银、珠宝、钻石、首饰、古币、古玩、古书、古画、邮票、艺术品、稀有金属等珍贵财物，红木家具等及其他难以客观确定保险价值的货物。 "
                  )
                ]),
                _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
                  _vm._v(" 1.1类 7类危险品；"),
                  _c("br"),
                  _vm._v(" 2.体积庞大或包装不善的货物；"),
                  _c("br"),
                  _vm._v(" 3.鲜活动植物、水果、蔬菜、禽鱼类；"),
                  _c("br"),
                  _vm._v(" 4.车辆、航空器、船舶及有关运输设备；"),
                  _c("br"),
                  _vm._v(" 5.枪支弹药、爆炸品、放射性同位素、军用武器或装备；"),
                  _c("br"),
                  _vm._v(
                    " 6.拖驳运输的货物，以及通过非正常贸易方式买卖的货物；"
                  ),
                  _c("br"),
                  _vm._v(
                    " 7.舱面货及甲板货（集装箱船运输的集装箱货不属于此范畴）"
                  ),
                  _c("br"),
                  _vm._v(
                    " 8.动植物及畜产品（已加工成成品或可以直接出售的不在此限，例如熟瓜子、牛肉干等）"
                  ),
                  _c("br"),
                  _vm._v(
                    " 9.体积小价值高的商品，是指体积小于30CM*30CM*30CM，单件价值高于RMB3万的商品；"
                  ),
                  _c("br"),
                  _vm._v(
                    " 10.精密设备或仪器（精密设备的判断条件是:A.对运输有特别的防震动、防倾斜、防尘等特殊要求。B.受国内维修能力所限，设备受损后无法在国内修复。C.单件货物保额超过RMB500万元(平安200万元）。满足上述条件之一的即为精密设备或仪器）；"
                  ),
                  _c("br"),
                  _vm._v(
                    " 11.工艺品（包括各类雕刻、编制品、刺绣、瓷器、玉器等）、现金、有价证券、计算机软件、金银、珠宝、钻石、首饰、古币、古玩、古书、古画、邮票、艺术品、稀有金属等珍贵财物，红木家具等及其他难以客观确定保险价值的货物。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 12.各种散装货物、谷物粮食 (包括但不限于大豆、大米、玉米、小麦、葵花籽、线麻籽等)、饲料类货物（包括但不限于豆粕、菜粕、鱼粉、DDGS等）、矿石、氧化铝、硫磺、化肥、棉花、原木、水泥、橡胶、黄金、烟用丝束、军火、罐头食品等。"
                  ),
                  _c("br")
                ]),
                _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
                  _vm._v(" 被保险人/投保人均在境外的机构；"),
                  _c("br"),
                  _vm._v(
                    " 载于20年以上船龄或总吨500吨以下小型船舶上的货物运输。"
                  ),
                  _c("br")
                ]),
                _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
                  _vm._v(
                    " 1) 精密仪器（精密仪器的判断条件是:A.对运输有特别的防震动、防倾斜、防尘等特殊要求。B.受 国内维修能力所限，设备受损后无法在国内修复。C.单件货物保额超过 RMB500 万元。满足上述 条件之一的即为精密设备或仪器）；"
                  ),
                  _c("br"),
                  _vm._v(" 2) 鲜活动植物；"),
                  _c("br"),
                  _vm._v(
                    " 3) 大宗散货（包括散装的农产品、化工产品、煤、油品）；"
                  ),
                  _c("br"),
                  _vm._v(
                    " 4) 工艺品（包括各类雕刻、编制、刺绣、古董、字画、瓷器、玉石等）、现金、有价证券、珠宝以 及计算机软件等难以客观确定保险价值的货物；"
                  ),
                  _c("br"),
                  _vm._v(" 5) 航空器、船舶及有关运输设备；"),
                  _c("br"),
                  _vm._v(" 6) 武器、弹药及其零配件；"),
                  _c("br")
                ])
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "30px" }, attrs: { gutter: 22 } },
              [
                _c(
                  "el-col",
                  { staticClass: "left-20-top-8", attrs: { span: 2 } },
                  [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("Insurance.SpecialAgreement")))
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "col-style",
                    staticStyle: { "text-align": "center" },
                    attrs: { span: 5 }
                  },
                  [_vm._v(" 裸装货物剔除刮擦锈损 ")]
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "col-style",
                    staticStyle: { "text-align": "center" },
                    attrs: { span: 5 }
                  },
                  [_vm._v(" 无 ")]
                ),
                _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
                  _vm._v(
                    " 1. 保险人理解并同意从保单上列明的终止日期开始到30天之内，被保险货物在最后达到保单上列明的最终目的地止，且被保险货物在保单终止日期前已出运，承担保险货物到达最终仓库期间的保险责任。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 2. 被保货物在连续72小时内遭受暴风雨、台风、洪水或地震所导致的所有损失应视为一次单独事件，在计算赔偿时视为一次保险事故。每个事件以第一个属于承保风险且导致被保货物损失的情况发生为起始时间。尽管如此，若超过连续72小时但损失发生的原因仍属于先前同样的情况，对于由此造成的损失仅适用一次免赔额。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 3、运输设备为船龄小于25年的钢质自航集装箱船舶、飞机、火车、适货汽车"
                  ),
                  _c("br"),
                  _vm._v(" 4.裸装货物剔除刮擦锈损 ")
                ]),
                _c("el-col", { staticClass: "col-style", attrs: { span: 5 } }, [
                  _vm._v(
                    " （一）被保险人的故意行为或过失所造成的损失。 （如未能及时提货造成的损失）"
                  ),
                  _c("br"),
                  _vm._v(
                    " （二）属于发货人责任所引起的损失。 （如漏发错发，积载不当，包装不善）"
                  ),
                  _c("br"),
                  _vm._v(
                    " （三）在保险责任开始前，被保险货物已存在的品质不良或数量短差所造成的损失。"
                  ),
                  _c("br"),
                  _vm._v(
                    " （四）被保险货物的自然损耗、本质缺陷、特性以及市价跌落、运输延迟所引起的损失或费用。"
                  ),
                  _c("br"),
                  _vm._v(" （五）保单载明的其他除外责任。 ")
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      [
        _c(
          "el-dialog",
          {
            directives: [
              { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
            ],
            staticClass: "make-invoice-select-invoice-dialog",
            attrs: {
              visible: _vm.insureDialog.visible,
              width: "550px",
              "close-on-click-modal": false,
              "show-close": false,
              "custom-class": "app-main-content"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.insureDialog, "visible", $event)
              }
            }
          },
          [
            _c("template", { slot: "title" }, [
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("Insurance.ClickToDownloadTemplate")) +
                      " "
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.downTemplate }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DownloadTemplate")))]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              {
                staticStyle: { "font-size": "16px", "text-align": "center" },
                attrs: { type: "warning" }
              },
              [
                _c(
                  "el-upload",
                  {
                    ref: "upload",
                    attrs: {
                      data: _vm.option,
                      drag: "",
                      accept: ".xls, .xlsx",
                      headers: { sessionId: _vm.sessionId },
                      "show-file-list": false,
                      action: _vm.URL.seaExport.freightImportInsurance,
                      "before-upload": _vm.handleBeforeUpload,
                      "on-progress": _vm.importProgress,
                      "on-success": _vm.importSuccess,
                      "on-error": _vm.importFaild
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v(_vm._s(_vm.$t("Insurance.DragFile"))),
                      _c("em", [
                        _vm._v(_vm._s(_vm.$t("Insurance.ClickToUpload")))
                      ])
                    ])
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: { "text-align": "center" },
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c("el-button", { on: { click: _vm.cancelDialog } }, [
                  _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
                ]),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.toInsure(_vm.insureDialog.agent)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("Insurance.FillInsuranceInformation")))]
                )
              ],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }